/**
 * Fast deterministic hash for source text comparison during sync.
 */
export function hashSourceText(text: string): string {
  let hash = 5381;
  const normalized = text.replace(/\s+/g, " ").trim();
  for (let i = 0; i < normalized.length; i++) {
    hash = hash * 33 ^ normalized.charCodeAt(i);
  }
  return (hash >>> 0).toString(36);
}
export function generateSectionId(): string {
  return `sec-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
}